// extracted by mini-css-extract-plugin
export default {"container":"Newest_container__ybVMQ","subContainer":"Newest_subContainer__x2BMn","cardsContainer":"Newest_cardsContainer__r+-Dx","loadMore":"Newest_loadMore__eitV4"};